import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/store';
import { selectIsAuthenticated, selectIsInitialized } from '@entities/session';
import { ROUTES } from '@shared/config';
import { Spinner } from '@shared/ui';

export function RequireAuth() {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isInitialized = useAppSelector(selectIsInitialized);

  if (!isInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
